module.exports = __webpack_public_path__ + "static/media/Health.df84eef9.svg";